<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-base-dialog v-model="isShowPop" :option="popOption" @close="isShowPop=false" v-transfer-dom></c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CButtonQualifications',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-Qualifications-',
      status: 'qualifications',
      isShowPop: false,
    };
  },
  computed: {
    backgroundImageMap() {
      return {
        qualifications: this.configurationData.qualificationsImg,
        qualificationsed: this.configurationData.qualificationsedImg,
      };
    },
    popOption() {
      return Object.assign({}, this.dialogConfig, {
        dialogStyle: {
          backgroundImage: `url(${this.configurationData.popImg})`,
        },
        header: false,
        body: false,
        fotter: false,
      });
    },
    computedStyle() {
      const { isStretching } = this.configurationData;
      return {
        backgroundImage: `url(${this.backgroundImageMap[this.status]})`,
        backgroundSize: isStretching ? '' : 'contain', // 是否拉伸
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
  },
  mounted() {
    console.log('version = 1.0.19 configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.doQualifications, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
      });
      const self = this;
      const checkStatus = () => {
        if (self.enable) self.status = 'qualifications';
        else self.status = 'qualificationsed';
        console.log('on checkStatus this.status=', self.status);
      };
      this.$onQuaRefreshed(checkStatus);
    },
    async doQualifications() {
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      // 已灰  不能再点击
      if (this.status === 'qualificationsed') {
        return;
      }
      // await this.doHook({
      //   name: 'click_Qualifications',
      //   options: {
      //     meta: this.meta,
      //     configurationData: this.configurationData,
      //   },
      // });
      // if (!(await this.doHook({ name: 'before_Qualifications' }))) {
      //   return;
      // }
      if (this.configurationData.operationType === 'share') {
        let link = common.tool.setUrlParam(
          'c_invite_code', '',
          this.shareConfig.link || window.location.href,
        );
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);
        link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
        const shareNewConfig = {
          title: this.shareConfig.title,
          link,
          desc: this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
          icon: this.shareConfig.icon, // 分享后朋友看到的图标
        };
        if (this.$ast.isAPP()) {
          this.$ast.setAPPShare(shareNewConfig);
          this.$ast.goAPPShare();
        } else {
          this.doShare(shareNewConfig);
        }
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
        },
      });
      // await this.doHook({
      //   name: 'after_Qualifications',
      //   options: {
      //     meta: this.meta,
      //     configurationData: this.configurationData,
      //     response,
      //   },
      // });
      // 后置动作，上报等
      if (response.ret || response.data.ret) {
        console.log('response.data.ret');
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'qualifications',
          eventData: {
            gift_id: '',
            status: '0',
          },
        });
      } else {
        this.reportClickRaw({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'qualifications',
          eventData: {
            gift_id: response.data.package_id || '',
            status: '1',
          },
        });
      }
      if (this.configurationData.operationType === 'pop') {
        this.isShowPop = true;
      } else if (this.configurationData.operationType === 'jump') {
        let link = this.configurationData.jumpUrl;
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);

        window.location.href = link;
      }
      this.status = 'qualificationsed';
      const that = this;
      setTimeout(() => {
        that.refreshQua(); // 刷新礼包
      }, 1500);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
